/**
 * @deprecated
 */
import $ from 'jquery';

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
	window.q.forEach((f) => {
		$(f);
	});
}


/**
 * URL checker
 * This is to check if the link has target blank,
 * if not and the url is not uhk native, add target blank.
 */

for (var links = document.links, i = 0, a; a = links[i]; i++) {
	if (a.target !== '_blank' && a.host !== location.host && !a.href.includes('javascript')) {
		a.target = '_blank';
		a.rel = 'noopener';
	}
}


/**
 * Sticky Menu
 */

window.addEventListener("scroll", function () {
	showToTopLink();
	const fulltextDropdown = document.getElementById('js_fulltextDropdown');
	const navbar = document.getElementById("headerMain");

	if (!fulltextDropdown.classList.contains('opened')) {
		if (window.pageYOffset > 100) {
			document.body.style.paddingTop = 40 + 'px';
			navbar.classList.add("sticky");
			navbar.parentElement.classList.add("sticky-bg");
		}
		if (window.pageYOffset <= 100) {
			navbar.classList.remove("sticky");
			navbar.parentElement.classList.remove("sticky-bg");
			document.body.style.paddingTop = 0 + 'px';
		}
	}
});


/**
 * Odscrollování na kotvu pokud je sticky menu
 */
$(document).on('click', 'a', function () {
	var topOffset = 120;
	var href = $(this).attr("href");
	var targetElement = href.substr(href.indexOf("#")).substr(1);

	if (window.pageYOffset > 100) {
		topOffset = 100;
	}

	if (targetElement !== '' && targetElement !== null && $('#' + targetElement).length) {
		$('html, body').animate({
			scrollTop: parseInt($('#' + targetElement).offset().top - topOffset)
		}, 150, 'linear');
	}
});

/**
 * to Top JS
 * @type {Element}
 */

let toTop = document.getElementsByClassName("js_toTop")[0];

// When the user scrolls down 120px from the top of the document, show the button
function showToTopLink() {
	if (toTop) {
		if (document.body.scrollTop > 120 || document.documentElement.scrollTop > 120) {
			toTop.classList.add("active");
		} else {
			toTop.classList.remove("active");
		}
	}
}

/**
 * Skip to submenu
 */
const skipItemSubmenu = document.querySelector('.skip__item--submenu');
if (skipItemSubmenu && document.querySelectorAll('nav.side-menu').length === 0 && document.querySelectorAll('nav.column-links').length === 0) {
  skipItemSubmenu.remove();
}
const firstHeader = document.querySelectorAll('h1:not(.header__logo)')[0];
if (firstHeader) {
  firstHeader.setAttribute('id','mainContent');
}



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/web.js